import { render, staticRenderFns } from "./FooterContentComponent.vue?vue&type=template&id=ad4700e8"
import script from "./FooterContentComponent.vue?vue&type=script&lang=js"
export * from "./FooterContentComponent.vue?vue&type=script&lang=js"
import style0 from "./FooterContentComponent.vue?vue&type=style&index=0&id=ad4700e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports